<template>
  <div>
    <h3 class="display-4" @click="enableDebug($event)">Maintenance List</h3>

    <o-list-toolbar
      :filters-list="filter_list"
      :search-fields-list="search_field_list"
      :selected-filter="selected_filter"
      :list-options="list_options"
      @reset_table="reset_table"
      @options_changed="update_table($event)"
      @filter_changed="update_filter($event)"
      :schema="schema"
      :query-select-options="options"
      :new-to="{ name: 'service_maintenance.create', params: { id: 0 } }"
      new-button-text="New Maintenance"
    >
      <template slot="middle">
        <!-- <o-list-multi-actions
          :schema="schema"
          :selection="selected"
          @delete="doDeleteItems"
          @merge="doMergeItems"
          enable-delete
          enable-merge
        /> -->
      </template>
    </o-list-toolbar>
    <!-- @row-selected="onRowSelected"
      :selectable="selected.selectable" :key="selected.selectable" -->
    <b-table
      striped
      bordered
      :tbody-tr-class="calculateRowClass(items)"
      :fields="fields"
      :items="items"
      head-variant="light"
      class="o-list"
      thead-class="o-gradient-header position-sticky"
      sticky-header="70vh"
      no-local-sorting
      @sort-changed="change_sort"
      :sort-by="list_options.sort"
      :sort-desc="list_options.order === 'desc'"
    >
      <template v-slot:cell(_selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not selected</span>
        </template>
      </template>
      <template slot="cell(id)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_maintenance.edit', params: { id: item.id } }"
          :when="first_column_key === 'id'"
        >
          <default-display :value="item.id"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(active_end_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_maintenance.edit', params: { id: item.id } }"
          :when="first_column_key === 'active_end_date'"
        >
          <date-display
            :value="item.active_end_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(active_start_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_maintenance.edit', params: { id: item.id } }"
          :when="first_column_key === 'active_start_date'"
        >
          <date-display
            :value="item.active_start_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(amount)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_maintenance.edit', params: { id: item.id } }"
          :when="first_column_key === 'amount'"
        >
          <number-display :value="item.amount" :decimals="2" />
        </o-link-cell>
      </template>
      <template slot="cell(amount_inc)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_maintenance.edit', params: { id: item.id } }"
          :when="first_column_key === 'amount_inc'"
        >
          <number-display :value="item.amount * 1.1" :decimals="2" />
        </o-link-cell>
      </template>
      <template slot="cell(builder)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_maintenance.edit', params: { id: item.id } }"
          :when="first_column_key === 'builder'"
        >
          <lookup-display
            :list="optionCustomerItemsById"
            :value="item.builder"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(cancelled_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_maintenance.edit', params: { id: item.id } }"
          :when="first_column_key === 'cancelled_date'"
        >
          <date-display
            :value="item.cancelled_date"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(code)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_maintenance.edit', params: { id: item.id } }"
          :when="first_column_key === 'code'"
        >
          <default-display :value="item.code"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(comments)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_maintenance.edit', params: { id: item.id } }"
          :when="first_column_key === 'comments'"
        >
          <default-display :value="item.comments"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(completed_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_maintenance.edit', params: { id: item.id } }"
          :when="first_column_key === 'completed_date'"
        >
          <date-display
            :value="item.completed_date"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(created_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_maintenance.edit', params: { id: item.id } }"
          :when="first_column_key === 'created_date'"
        >
          <date-display
            :value="item.created_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(date_po_supplied)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_maintenance.edit', params: { id: item.id } }"
          :when="first_column_key === 'date_po_supplied'"
        >
          <date-display
            :value="item.date_po_supplied"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(date_quoted)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_maintenance.edit', params: { id: item.id } }"
          :when="first_column_key === 'date_quoted'"
        >
          <date-display
            :value="item.date_quoted"
            format="DD/MM/YYYY"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(description)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_maintenance.edit', params: { id: item.id } }"
          :when="first_column_key === 'description'"
        >
          <default-display :value="item.description"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(extra)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_maintenance.edit', params: { id: item.id } }"
          :when="first_column_key === 'extra'"
        >
          <lookup-display
            :list="optionServiceExtraItemsById"
            :value="item.extra"
            display-field="description"
            default-value="-"
          ></lookup-display>
        </o-link-cell>
      </template>
      <template slot="cell(invoices)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_maintenance.edit', params: { id: item.id } }"
          :when="first_column_key === 'invoices'"
        >
          <default-display :value="item.invoices"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(job)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_maintenance.edit', params: { id: item.id } }"
          :when="first_column_key === 'job'"
        >
          <default-display :value="item.job"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(modified_date)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_maintenance.edit', params: { id: item.id } }"
          :when="first_column_key === 'modified_date'"
        >
          <date-display
            :value="item.modified_date"
            format="DD/MM/YYYY hh:mm"
          ></date-display>
        </o-link-cell>
      </template>
      <template slot="cell(old_job_no)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_maintenance.edit', params: { id: item.id } }"
          :when="first_column_key === 'old_job_no'"
        >
          <default-display :value="item.old_job_no"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(po_no_supplied)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_maintenance.edit', params: { id: item.id } }"
          :when="first_column_key === 'po_no_supplied'"
        >
          <default-display :value="item.po_no_supplied"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(purchase_order_number)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_maintenance.edit', params: { id: item.id } }"
          :when="first_column_key === 'purchase_order_number'"
        >
          <default-display
            :value="item.purchase_order_number"
          ></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(quoted_by)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_maintenance.edit', params: { id: item.id } }"
          :when="first_column_key === 'quoted_by'"
        >
          <default-display :value="item.quoted_by"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(quoted_by_id)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_maintenance.edit', params: { id: item.id } }"
          :when="first_column_key === 'quoted_by_id'"
        >
          <number-display :value="item.quoted_by_id" :decimals="0" />
        </o-link-cell>
      </template>
      <template slot="cell(repair_files)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_maintenance.edit', params: { id: item.id } }"
          :when="first_column_key === 'repair_files'"
        >
          <default-display :value="item.repair_files"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(repair_notes)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_maintenance.edit', params: { id: item.id } }"
          :when="first_column_key === 'repair_notes'"
        >
          <default-display :value="item.repair_notes"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(site_address)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_maintenance.edit', params: { id: item.id } }"
          :when="first_column_key === 'site_address'"
        >
          <default-display :value="item.site_address"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(suburb)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_maintenance.edit', params: { id: item.id } }"
          :when="first_column_key === 'suburb'"
        >
          <default-display :value="item.suburb"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(supervisor)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_maintenance.edit', params: { id: item.id } }"
          :when="first_column_key === 'supervisor'"
        >
          <default-display :value="item.supervisor_name"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(supervisor_name)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_maintenance.edit', params: { id: item.id } }"
          :when="first_column_key === 'supervisor_name'"
        >
          <default-display :value="item.supervisor_name"></default-display>
        </o-link-cell>
      </template>
      <template slot="cell(used_materials)" slot-scope="{ index, item }">
        <o-link-cell
          :to="{ name: 'service_maintenance.edit', params: { id: item.id } }"
          :when="first_column_key === 'used_materials'"
        >
          <default-display :value="item.used_materials"></default-display>
        </o-link-cell>
      </template>

      <template slot="empty">
        <p>
          <emoticon-sad-icon large></emoticon-sad-icon>
        </p>
        No Data Found. Please
        <router-link :to="{ name: 'service_maintenance.create' }"
          >create a new item</router-link
        >
      </template>
    </b-table>

    <o-list-paging
      :limit="list_options.limit"
      :page-options="rows_per_page_items"
      :offset="list_options.offset"
      :total-items="total_items"
      @change-limit="change_limit"
      @change-page="change_page"
    />
  </div>
</template>

<style>
tr.maint_quote_required > td {
  background-color: lightyellow;
}

tr.maint_quoted > td {
  background-color: lightyellow;
}

tr.maint_active > td {
  background-color: lightgreen;
}
tr.maint_completed > td {
  background-color: silver;
}

tr.maint_cancelled > td {
  background-color: salmon;
}

tr.maint_extra_no_req > td {
  /* Orange */
  background-color: rgba(240, 135, 4, 0.58);
}
</style>

<script>
import {
  CreateCodeTableFetchMixin,
  CreateGroupPermissionMixin,
  CreateListPageMixin,
  MultiActionsMixin,
} from "../../../vue-ocom/mixins";
import {
  fieldToTableColumn,
  GetSearchFields,
} from "../../../vue-ocom/schema/schema_utils";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import schema from "../../schema/index";

import OListToolbar from "../../../vue-ocom/components/list/OListToolbar";
import OListPaging from "../../../vue-ocom/components/list/OListPaging";
import DefaultDisplay from "../../../vue-ocom/components/display/DefaultDisplay";
import DateDisplay from "../../../vue-ocom/components/display/DateDisplay";
import NumberDisplay from "../../../vue-ocom/components/display/NumberDisplay";
import BooleanDisplay from "../../../vue-ocom/components/display/BooleanDisplay";
import LookupDisplay from "../../../vue-ocom/components/display/LookupDisplay";
import EmoticonSadIcon from "vue-material-design-icons/EmoticonSad";
import EmailIcon from "vue-material-design-icons/Email";
import LinkIcon from "vue-material-design-icons/Link";

export default {
  components: {
    EmoticonSadIcon,
    EmailIcon,
    LinkIcon,
    OListPaging,
    OListToolbar,
    DateDisplay,
    DefaultDisplay,
    BooleanDisplay,
    NumberDisplay,
    LookupDisplay,
  },
  mixins: [
    CreateListPageMixin(
      "ServiceMaintenance",
      "service_maintenance",
      "active_jobs"
    ),
    MultiActionsMixin,
    CreateGroupPermissionMixin("ServiceMaintenance"),
    CreateCodeTableFetchMixin(["Customer", "ServiceExtra", "Supervisor"]),
  ],
  data: function () {
    return {
      schemaModel: cleanUpModel(
        schema.ServiceMaintenance,
        {}
      ) /*Use this.schema instead */,

      search_field_list: GetSearchFields(schema.ServiceMaintenance),

      filterRow: true /* Set to False to disable filter row */,
      filter_list: [
        {
          name: "Active (PO Received)",
          code: "active_jobs",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Quote Required",
          code: "quote_required",
          options: { offset: 0, sort: "id" },
        },
        { name: "Quoted", code: "quoted", options: { offset: 0, sort: "id" } },

        {
          name: "Extra No Req",
          code: "extrano_req",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Completed",
          code: "completed",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "Cancelled",
          code: "cancelled",
          options: { offset: 0, sort: "id" },
        },
        {
          name: "All",
          code: "all",
          options: { offset: 0, sort: "job__id", order: "desc" },
        },
      ],

      user_column_selection: null /* If user can customise the columns set them here */,
      column_override_params: {
        /* Put any column overrides here key by fieldname */
        id: { label: "No." },
        code: { label: "Maint Req No." },
        extra: { label: "Extra No." },
      },
    };
  },
  methods: {
    cell_style(value, key, item) {
      if (key === "amount_inc" || key === "amount") {
        return "text-right";
      }
      return null;
    },
    addTdClass(entries) {
      entries.forEach(function (entry) {
        if (entry) {
          entry["tdClass"] = "cell_style";
        }
      });
    },
    calculateRowClass(item, type) {
      if (item && type === "row") {
        this.cell_style(null, "", item);
      }
      var result = "";

      if (item.date_quoted == null) {
        // Quote Required
        result = "maint_quote_required"; // Yellow
      }
      // (("service_maintenance"."purchase_order_number" IS NULL OR "service_maintenance"."purchase_order_number" = ) AND "service_maintenance"."date_quoted" IS NOT NULL AND "service_maintenance"."cancelled_date" IS NULL AND "service_maintenance"."completed_date" IS NULL)
      if (
        item.date_quoted &&
        item.cancelled_date == null &&
        (item.purchase_order_number == null ||
          item.purchase_order_number == "") &&
        item.completed_date == null
      ) {
        // Quoted
        result = "maint_quoted"; // Yellow
      }
      if (
        item.date_quoted != null &&
        item.date_po_supplied != null &&
        item.cancelled_date == null &&
        item.completed_date == null
      ) {
        // Active
        result = "maint_active"; // Green
      }
      if (item.completed_date != null) {
        result = "maint_completed"; // Grey
      }
      if (item.cancelled_date != null) {
        result = "maint_cancelled"; // Red
      }
      if (
        item.completed_date != null &&
        item.purchase_order_number != null &&
        item.extra == null
      ) {
        result = "maint_extra_no_req"; // orange
      }

      return result;
    },
  },
  computed: {
    options() {
      return {
        Customer: {
          options: this.optionCustomerItems,
          textField: "name",
          valueField: "id",
        },
        ServiceExtra: {
          options: this.optionServiceExtraItems,
          textField: "description",
          valueField: "id",
        },
        Job: {
          options: this.optionJobItems,
          textField: "description",
          valueField: "id",
        },
        Supervisor: {
          options: this.optionSupervisorItems,
          textField: "name",
          valueField: "id",
        },
      };
    },
    fields() {
      const vm = this;
      const selectedColumns = this.user_column_selection || [
        "id",
        "date_quoted",
        "code",
        "supervisor",
        "purchase_order_number",
        "job__id",
        "site_address",
        "suburb",
        "description",
        "amount",
        "amount_inc",
        "quoted_by",
        "po_no_supplied",
        "date_po_supplied",
        "comments",
        "completed_date",
        "extra",
      ];
      const fields = selectedColumns.map(function (item) {
        return fieldToTableColumn(
          vm.schema,
          item,
          vm.column_override_params[item]
        );
      });

      this.addTdClass(this.filterTableColumns(this.schema, fields));

      return this.addSelectionColums(
        this.filterTableColumns(this.schema, fields)
      );
    },
    first_column_key() {
      if (this.fields) {
        return this.fields[0].key;
      } else {
        return null;
      }
    },
  },
};
</script>
